import { useCallback } from 'react';

import { MarketingContentPreview, TableCell, TableRow, Typography } from '@occc-app/design-system';
import { statusBadge } from '@occc-app/lib/publicationStatusBadge';
import { LoyaltyEventsListItemFragment } from '@occc/graphql';

import { LoyaltyEventActionsContainer } from './LoyaltyEventActionsContainer';

type LoyaltyEventTableRowProps = {
  offer: LoyaltyEventsListItemFragment;
  onItemClick: (id: string) => void;
  isEditActionVisible: boolean;
  isArchiveActionVisible: boolean;
  areActionsVisible: boolean;
};

export const LoyaltyEventTableRow = ({
  offer,
  onItemClick,
  isEditActionVisible,
  isArchiveActionVisible,
  areActionsVisible,
}: LoyaltyEventTableRowProps) => {
  const {
    id,
    name,
    marketingContents,
    deleted,
    fulfillmentCount,
    publicationStatus,
    visibleForCommandCenterFulfillment,
    earningMechanism,
  } = offer;

  const handleItemClick = useCallback(() => {
    onItemClick(id);
  }, [id, onItemClick]);

  return (
    <TableRow onClick={handleItemClick}>
      <TableCell>
        <Typography>{name}</Typography>
      </TableCell>
      <TableCell>
        <Typography>
          {earningMechanism?.__typename === 'EarningMechanismLoyaltyEvent'
            ? earningMechanism.loyaltyEventEventType
            : ''}
        </Typography>
      </TableCell>
      <TableCell>
        <MarketingContentPreview
          title={marketingContents?.[0]?.title || 'No Name Provided'}
          description={marketingContents?.[0]?.shortDescription || 'No Description Provided'}
          imageUrl={marketingContents?.[0]?.imageUrl ?? undefined}
        />
      </TableCell>
      <TableCell>{statusBadge(deleted, publicationStatus)}</TableCell>
      <TableCell>{visibleForCommandCenterFulfillment ? 'Yes' : 'No'}</TableCell>
      <TableCell align='center'>{fulfillmentCount}</TableCell>
      {areActionsVisible ? (
        <TableCell padding='button' align='right'>
          <LoyaltyEventActionsContainer
            id={id}
            name={name}
            isEditActionVisible={isEditActionVisible}
            isArchiveActionVisible={isArchiveActionVisible && !deleted}
          />
        </TableCell>
      ) : null}
    </TableRow>
  );
};
